class SVGPreloader {
  constructor() {
    this.svgCache = new Map();
    this.loadedCount = 0;
    this.totalCount = 0;
    this.onProgressCallback = null;
    this.onCompleteCallback = null;
  }

  getAllSVGPaths() {
    const svgPaths = [
      // Main game options
      require("../assets/svg/gameOptions1.svg"),
      require("../assets/svg/gameOptions2.svg"),
      require("../assets/svg/gameOptions3.svg"),
      require("../assets/svg/gameOptions4.svg"),
      require("../assets/svg/gameOptions5.svg"),
      require("../assets/svg/gameOptions6.svg"),
      
      // UI SVGs
      require("../assets/svg/global-home.svg"),
      require("../assets/svg/dart-off-left.svg"),
      require("../assets/svg/dart-off-right.svg"),
      require("../assets/svg/dart-target.svg"),
      require("../assets/svg/happy-play.svg"),
      require("../assets/svg/how-to-earn.svg"),
      require("../assets/svg/how-to-fund.svg"),
      require("../assets/svg/how-to-play.svg"),
      require("../assets/svg/lostIcon.svg"),
      require("../assets/svg/modal-next.svg"),
      require("../assets/svg/nav-settings-large.svg"),
      require("../assets/svg/nav-settings.svg"),
      require("../assets/svg/thumbs-up.svg"),
      require("../assets/svg/watch-demo.svg"),
      require("../assets/svg/wonIcon.svg"),
    ];

    // Add legacy selectors
    for (let category = 1; category <= 6; category++) {
      for (let item = 1; item <= 9; item++) {
        try {
          svgPaths.push(require(`../assets/svg/legacy-selectors/${category}/${item}.svg`));
        } catch (e) {
          console.warn(`SVG not found: legacy-selectors/${category}/${item}.svg`);
        }
      }
    }

    return svgPaths;
  }

  preloadSVG(url) {
    return new Promise((resolve, reject) => {
      if (this.svgCache.has(url)) {
        resolve(this.svgCache.get(url));
        return;
      }

      const img = new Image();
      
      img.onload = () => {
        this.svgCache.set(url, url);
        this.loadedCount++;
        
        if (this.onProgressCallback) {
          const progress = (this.loadedCount / this.totalCount) * 100;
          this.onProgressCallback(progress, this.loadedCount, this.totalCount);
        }
        
        resolve(url);
      };

      img.onerror = () => {
        console.warn(`Failed to load SVG: ${url}`);
        this.loadedCount++;
        
        if (this.onProgressCallback) {
          const progress = (this.loadedCount / this.totalCount) * 100;
          this.onProgressCallback(progress, this.loadedCount, this.totalCount);
        }
        
        resolve(null);
      };

      img.src = url;
    });
  }

  async preloadAllSVGs() {
    const svgPaths = this.getAllSVGPaths();
    this.totalCount = svgPaths.length;
    this.loadedCount = 0;

    const promises = svgPaths.map(path => this.preloadSVG(path));
    
    try {
      await Promise.allSettled(promises);
      
      if (this.onCompleteCallback) {
        this.onCompleteCallback(this.svgCache);
      }
      
      return this.svgCache;
    } catch (error) {
      console.error('Error preloading SVGs:', error);
      throw error;
    }
  }

  onProgress(callback) {
    this.onProgressCallback = callback;
  }

  onComplete(callback) {
    this.onCompleteCallback = callback;
  }

  isSVGLoaded(url) {
    return this.svgCache.has(url);
  }

  getLoadedSVGs() {
    return this.svgCache;
  }
}

export default new SVGPreloader();